import styled from "styled-components";

export const Select = styled.select`
  height: ${props => props.height || "1.5rem"};
  width: ${props => props.width || "auto"};
  padding-left: ${props => props.labelPadding || ".25rem"};
  font-size: 11px;
  box-sizing: border-box;
  border: ${props =>
    props.borderColor
      ? `1px solid ${props.borderColor}`
      : `1px solid ${props.theme.border}`};
  border-radius: 0;
  color: ${props => props.theme.input.text};
  position: relative;
  padding-right: 1.5rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: ${props => props.theme.input.background};

  background-image: linear-gradient(
      45deg,
      transparent 50%,
      ${props => props.theme.text.primary} 50%
    ),
    linear-gradient(
      135deg,
      ${props => props.theme.text.primary} 50%,
      transparent 50%
    ),
    linear-gradient(to right, transparent, transparent);
  background-position: calc(100% - 10px) 50%, calc(100% - 5px) 50%, 100% 0;
  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
  background-repeat: no-repeat;

  /* Hides the arrow for IE */
  &::-ms-expand {
    display: none;
  }

  &.loading {
    background-image: url("images/inputLoading.gif");
    background-position: center right 1rem;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &:disabled {
    box-shadow: inset 0 0 0 10em ${props => props.theme.overlay};
    cursor: not-allowed;
  }
`;

export const SelectLabel = styled.label`
  position: absolute;
  z-index: 1;
  height: 1.5rem;
  padding-top: 0.15rem;
  margin-left: -0.5rem;
  pointer-events: none;
  text-indent: 1rem;
  color: ${props => props.theme.text.secondary};
`;



// WEBPACK FOOTER //
// ./app/styled-components/Select.js